import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { FormattedMenuSectionInfo } from 'api'
import styled from 'styled-components'
import DragHandle from './DragHandle'
import ItemModifierRow from '../ItemModifierRow'

interface Props {
  modifier: FormattedMenuSectionInfo
  customization: FormattedMenuSectionInfo
  modifierValues: { title: string; price?: number }
  onChangeModifierValues?: ({
    modId,
    price,
    title,
  }: {
    modId: string
    price?: number
    title?: string
  }) => void
  onDeleteModifier: (modId: string, customization: FormattedMenuSectionInfo) => void
  isPrinterClient?: boolean
  isItemModal?: boolean
  isEditor?: boolean
  modifiersExist?: boolean
  onRowClick?: () => void
  isExpanded?: boolean
  isSelected?: boolean
  onModifierClick?: (id: string) => void
  isPreviewOnly?: boolean
  setSuspendUntilItem?: any
  existingSuspendUntil?: string | null | undefined
  checkBoxContainerStyle?: React.CSSProperties
  isItemPreview?: boolean
  isNested?: boolean
}

const SortableModifierContainer = styled.div<{ isDragging?: boolean; isNested?: boolean }>`
  position: relative;
  overflow: visible;
  display: flex;
  align-items: center;
  ${({ isDragging }) => isDragging && `
    opacity: 1;
    z-index: 1000;
  `}
`

const DragHandleWrapper = styled.div<{ isItemModal?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 100%;
  flex-shrink: 0;
  padding-left: 12px;
  ${({ isItemModal }) => isItemModal && `
    margin-right: 16px;
  `}
`

const SortableModifierItem = ({
  modifier,
  customization,
  modifierValues,
  onChangeModifierValues,
  onDeleteModifier,
  isPrinterClient,
  isItemModal,
  isEditor,
  modifiersExist,
  onRowClick,
  isExpanded,
  isSelected,
  onModifierClick,
  isPreviewOnly,
  setSuspendUntilItem,
  existingSuspendUntil,
  checkBoxContainerStyle,
  isItemPreview,
  isNested,
}: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: modifier.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const dragHandle = isPrinterClient ? (
    <DragHandleWrapper {...attributes} {...listeners} isItemModal={isItemModal}>
      <DragHandle id={modifier.id} />
    </DragHandleWrapper>
  ) : null;

  return (
    <SortableModifierContainer
      ref={setNodeRef}
      style={style}
      isDragging={isDragging}
    >
      <ItemModifierRow
        key={modifier.id}
        modifierId={modifier.id}
        modifier={modifierValues}
        customization={customization}
        onChangeModifierValues={onChangeModifierValues}
        onDeleteModifier={onDeleteModifier}
        isItemModal={isItemModal}
        dragHandle={dragHandle}
        modifiersExist={modifiersExist}
        onRowClick={onRowClick}
        isExpanded={isExpanded}
        isSelected={isSelected}
        onModifierClick={onModifierClick}
        isPreviewOnly={isPreviewOnly}
        setSuspendUntilItem={setSuspendUntilItem}
        existingSuspendUntil={existingSuspendUntil}
        checkBoxContainerStyle={checkBoxContainerStyle}
        isItemPreview={isItemPreview}
        isNested={isNested}
        isEditor={isEditor}
      />
    </SortableModifierContainer>
  )
}

export default SortableModifierItem 